import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const video = {

    state: {

    },

    mutations: {
        /**
         * 获取视频分类列表(分页)
         * @param state
         * @param data
         */
        getVideoCategoryLists(state, data) {
            data.url = API.video.getVideoCategoryLists;
            CommonUtils.GetRequest(data);
        },

        /**
         * 获取视频分类列表(不分页)
         * @param state
         * @param data
         */
        getVideoCategoryListsNoPagination(state, data) {
            data.url = API.video.getVideoCategoryListsNoPagination;
            CommonUtils.GetRequest(data);
        },

        /**
         * 启用/停用 视频分类
         * @param state
         * @param data
         */
        toggleVideoCategoryStatus(state, data) {
            data.url = API.video.toggleVideoCategoryStatus;
            CommonUtils.PostRequest(data);
        },

        /**
         * 删除视频分类
         * @param state
         * @param data
         */
        deleteVideoCategory(state, data) {
            data.url = API.video.deleteVideoCategory;
            CommonUtils.GetRequest(data);
        },

        /**
         * 添加视频分类
         * @param state
         * @param data
         */
        addVideoCategory(state, data) {
            data.url = API.video.addVideoCategory;
            CommonUtils.PostRequest(data);
        },

        /**
         * 获取视频分类详情
         * @param state
         * @param data
         */
        getVideoCategoryInfo(state, data) {
            data.url = API.video.getVideoCategoryInfo;
            CommonUtils.GetRequest(data);
        },

        /**
         * 更新视频分类详情
         * @param state
         * @param data
         */
        editVideoCategory(state, data) {
            data.url = API.video.editVideoCategory;
            CommonUtils.PostRequest(data);
        },

        /**
         * 获取视频列表数据(分页)
         * @param state
         * @param data
         */
        getVideoLists(state, data) {
            data.url = API.video.getVideoLists;
            CommonUtils.GetRequest(data);
        },

        /**
         * 上架/下架 视频
         * @param state
         * @param data
         */
        showVideo(state, data) {
            data.url = API.video.showVideo;
            CommonUtils.PostRequest(data);
        },

        /**
         * 置顶/取消置顶 视频
         * @param state
         * @param data
         */
        stickVideo(state, data) {
            data.url = API.video.stickVideo;
            CommonUtils.PostRequest(data);
        },

        /**
         * 推荐/取消推荐 视频
         * @param state
         * @param data
         */
        recommendVideo(state, data) {
            data.url = API.video.recommendVideo;
            CommonUtils.PostRequest(data);
        },

        /**
         * 删除视频
         * @param state
         * @param data
         */
        deleteVideo(state, data) {
            data.url = API.video.deleteVideo;
            CommonUtils.GetRequest(data);
        },

        addVideo(state, data) {
            data.url = API.video.addVideo;
            CommonUtils.PostRequest(data);
        },

        editVideo(state, data) {
            data.url = API.video.editVideo;
            CommonUtils.PostRequest(data);
        },

        getVideoInfo(state, data) {
            data.url = API.video.getVideoInfo;
            CommonUtils.GetRequest(data);
        }
    }

};

export default video;


// WEBPACK FOOTER //
// ./src/store/modules/video.js